import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { LoadingSpinner } from '@/components/loading/Loading';
import { useAuth } from '@/libs/device-auth/hooks/useAuth';
import { AuthStateType } from '@/libs/device-auth';
import { AppScreen } from '@/types/common';

/**
 * ProtectedRoute is for authenticated users only
 * If the user is not authenticated, redirect to LandingScreen
 * This component acts as a layout route that renders child routes via Outlet
 */
export const ProtectedRoute: React.FC = () => {
  const { isLoading, authStateType } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // If not authenticated, redirect to landing
  if (authStateType === AuthStateType.UNAUTHENTICATED) {
    return <Navigate to={AppScreen.LANDING} replace />;
  }

  // If all checks pass, render the nested routes via Outlet
  return <Outlet />;
};
